import apiV2 from '@/api/v2';
//TODO contract
export var GoodsOfferStatus;
(function (GoodsOfferStatus) {
    GoodsOfferStatus["DRAFT"] = "draft";
    GoodsOfferStatus["IN_OFFER"] = "in-offer";
    GoodsOfferStatus["IN_RESERVATION"] = "in-reservation";
    GoodsOfferStatus["IN_CONTRACT"] = "in-contract";
})(GoodsOfferStatus || (GoodsOfferStatus = {}));
export var GoodsOfferDecisionStatus;
(function (GoodsOfferDecisionStatus) {
    GoodsOfferDecisionStatus["ACCEPTED"] = "accepted";
    GoodsOfferDecisionStatus["REJECTED"] = "rejected";
    GoodsOfferDecisionStatus["REVERTED"] = "reverted";
})(GoodsOfferDecisionStatus || (GoodsOfferDecisionStatus = {}));
export var GoodsOfferDecisionType;
(function (GoodsOfferDecisionType) {
    GoodsOfferDecisionType["CENTRAL"] = "central";
    GoodsOfferDecisionType["STRUCTURE"] = "structure";
    GoodsOfferDecisionType["PLACE"] = "place";
})(GoodsOfferDecisionType || (GoodsOfferDecisionType = {}));
export const getGoodsOfferList = async (params) => {
    const { data } = await apiV2.get('/goods-offers', {
        params,
    });
    return data;
};
export const getGoodsOffer = async (id) => {
    const { data } = await apiV2.get(`/goods-offers/${id}`);
    return data;
};
export const getGoodsAndServices = async (goodsOfferId, params) => {
    const { data } = await apiV2.get(`/goods-offers/${goodsOfferId}/goods-and-services`, {
        params,
    });
    return data;
};
export const createOrUpdateGoodsOfferDecision = async (goodsOfferId, payload) => {
    const { data } = await apiV2.post(`/goods-offers/${goodsOfferId}/decision`, payload);
    return data;
};
